<template>
  <v-container>
    <v-layout row>
      <v-flex xs10 md7 offset-md2 pb-3>
        <v-btn flat class="primary" router @click="back">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </v-flex>
      <v-flex mt-1 v-if="isUserAdmin">
        <ModifyCourseType v-bind:courseType="courseTypeID" />
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="!loaded">
      <v-flex offset-xs5 offset-sm6 pt-5>
        <v-progress-circular :size="70" :width="7" color="light-blue darken-4" indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-flex xs12 md8 offset-md2>
      <v-card class="cardText cardBackground" v-if="loaded">
        <v-card-title primary-title>
          <v-layout row wrap>
            <v-flex xs12>
              <div pb-3 class="headline">{{ courseType.name }}</div>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-flex md6 offset-md1 mb-1>
            <div>{{courseType.description}}</div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import { db } from "../main";
import ModifyCourseType from "../components/ModifyCourseTypeDialog.vue";
export default {
  components: { ModifyCourseType },

  data: () => ({
    courseType: {
      name: "",
      description: ""
    },
    courseTypeID: "",
    loaded: false
  }),
  methods: {
    //metodo per far tornare l'utente alla pagina precedente
    back() {
      this.$store.dispatch("setCourseType", null);
      window.history.back();
    }
  },
  computed: {
    //controlla se l'utente è admin
    isUserAdmin() {
      return this.$store.getters.getRole === "Admin";
    }
  },
  //metodo per il recupero delle info sul Tipo Corso
  created() {
    this.courseTypeID = this.$store.getters.getCourseType;
    db.collection("tipi_corso")
      .doc(this.courseTypeID)
      .onSnapshot(querySnapshot => {
        this.courseType.name = querySnapshot.data().nome;
        this.courseType.description = querySnapshot.data().descrizione;
        this.loaded = true
      });
  }
};
</script>

